// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"63808f7a","377":"487d4329","417":"099d7aaf","467":"b4d4f4ce","626":"e5e40771","870":"16e7f445"}[chunkId] + ".js";
};